// UPLOAD
export const apiCreateContribute = "/chuyendoiso/api/v1/createContribute"
export const apiUploadFiles = "/chuyendoiso/api/v1/UploadFiles"
export const apiUploadReports = "/quytrinh/api/v1/UploadReports"
